<h1>{{ title }}</h1>
<pega-retail
    [caseTypeID]="caseTypeId"
    [content]="content"
    (assignmentComplete)="onAssignmentComplete($event)"
    (caseResume)="onCaseResumeOrChange($event)"
    (caseChange)="onCaseResumeOrChange($event.caseId)"
    (nextAction)="handleNextAction($event)"
>
</pega-retail>
